import { msg } from "@lit/localize";
import { createAsyncActionGroup } from "@progressive-development/pd-spa-helper";

import type { ris } from "@progressive-development/politik-model";

import type { Besetzung, GremiumDrucksachen, Sitzungen } from "../service/gremien-service.js";

/**
 * Die Bilanz der Wahlperiode — ein Dokument für alle Gremien.
 *
 * OHNE Nutzlast: Es gilt für alle zugleich und altert mit dem Pipeline-Lauf,
 * nicht mit dem Seitenwechsel — deshalb über `fireOnce` angestoßen.
 */
export const loadGremienKennzahlen = createAsyncActionGroup<
  void,
  ris.GremienKennzahlenDokument | undefined
>("LOAD_GREMIEN_KENNZAHLEN", {
  loadingTxt: msg("Kennzahlen werden geladen…", { id: "app.gremium.kennzahlen.loading.toast" }),
  smallBackground: true,
});

/**
 * Die zwei eigenen Ladevorgänge einer Gremiumsseite — mit der RIS-ID als
 * Nutzlast. Getrennt, weil sie verschiedene Fragen beantworten und getrennt
 * scheitern dürfen: Wer wissen will, wann das Gremium tagt, soll das auch
 * dann sehen, wenn die Drucksachen haken.
 */
export const loadGremiumSitzungen = createAsyncActionGroup<string, Sitzungen>(
  "LOAD_GREMIUM_SITZUNGEN",
  {
    loadingTxt: msg("Sitzungen werden geladen…", { id: "app.bv.sitzungen.loading.toast" }),
    smallBackground: true,
  },
);

export const loadGremiumDrucksachen = createAsyncActionGroup<string, GremiumDrucksachen>(
  "LOAD_GREMIUM_DRUCKSACHEN",
  {
    loadingTxt: msg("Drucksachen werden geladen…", { id: "app.gremium.drucksachen.loading.toast" }),
    smallBackground: true,
  },
);

/** Die Besetzung — alle Mitgliedschaften des Gremiums; was laufend ist, entscheidet die Anzeige. */
export const loadGremiumBesetzung = createAsyncActionGroup<string, Besetzung>(
  "LOAD_GREMIUM_BESETZUNG",
  {
    loadingTxt: msg("Besetzung wird geladen…", { id: "app.gremium.besetzung.loading.toast" }),
    smallBackground: true,
  },
);
